import React from "react";

// import FooterMain from "../Layout/FooterMain";
// import HeaderMain from "../Layout/HeaderMain";
 
import LastChanse from "./LastChanse";
import LastChanseApp from "./LastChanseApp";
import OfferPrdoctWeb from "./OfferPrdoctWeb";
import OfferProductApp from "./OfferProductApp";
import BestSellingWeb from "./BestSellingWeb";
import BestselleinApp from "./BestselleinApp";

function BestSellingProduct2({ cat, sliderdate }) {
  function isWebView() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Example for Android WebView (check for "wv")
    if (/wv/.test(userAgent) || /Android.*WebView/.test(userAgent)) {
      return true;
    }

    // Example for iOS WebView (check for "iPhone OS" without "Safari")
    if (/iPhone|iPod|iPad/.test(userAgent) && !/Safari/.test(userAgent)) {
      return true;
    }

    return false; // Assume it's a browser if no WebView signature is detected
  }

  if (isWebView()) {
    console.log("Running inside a WebView");
  } else {
    console.log("Running inside a browser");
  }
  return (
    <div>
      {isWebView() ? (
        <div>
          {/* <HeaderMain /> */}

          <BestselleinApp />

          {/* <FooterMain /> */}
        </div>
      ) : (
        <div>
          {/* <HeaderMain /> */}
          <BestSellingWeb />
          {/* <FooterMain /> */}
        </div>
      )}
    </div>
  );
}

export default BestSellingProduct2;
